export const SET_NATIONAL_ID = "SET_NATIONAL_ID";
export const SET_USAGE_MODAL = "SET_USAGE_MODAL";
export const SET_OTP_RETRIEVED = "SET_OTP_RETRIEVED";
export const SET_NAFATH_VERIFIED = "SET_NAFATH_VERIFIED";
export const SET_SELECTED_USER_TYPE = "SET_SELECTED_USER_TYPE";
export const SET_OTP = "SET_OTP";
export const SET_TRANS_ID = "SET_TRANS_ID";
export const SET_INDIVIDUAL_USER_EXIST = "SET_INDIVIDUAL_USER_EXIST";
